import React from "react";
import styled from "styled-components";

const GnbItemUpload = ({ ...rest }: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <WrapStyle {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
      >
        <circle cx="14" cy="14" r="13" fill="currentColor" />
        <path
          d="M14.0002 9.33337L14.0002 18.6667M18.6668 14L9.3335 14"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </WrapStyle>
  );
};

export default GnbItemUpload;

export const WrapStyle = styled.div`
  padding: 0.4rem;
  border-radius: 0.8rem;

  display: inline-flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.color.brick[700]};
    width: 2.8rem;
    height: 2.8rem;
  }

  &:hover {
    background: ${({ theme }) => theme.color.grey[300]};
  }

  &:active {
    svg {
      color: ${({ theme }) => theme.color.brick[500]};
    }
  }
`;
